import React from 'react';
import { StyleSheet } from 'react-native';
import Button from 'design-system/Button';
import { useBudgetingNavigate } from 'features/budgeting/hooks/useBudgetingNavigate';
const BudgetingSetupButton = () => {
    const { onNavigate } = useBudgetingNavigate();
    return (<Button brandLight cards title="Set up budgets" style={styles.setupButton} onPress={onNavigate}/>);
};
const styles = StyleSheet.create({
    setupButton: {
        alignSelf: 'flex-start',
    },
});
export default BudgetingSetupButton;
